import { WEIGHT_LABELS } from '@jane/bloom/dataAccess/constants';

export function weightLabel(weight: string) {
  return WEIGHT_LABELS[weight]?.toLowerCase() || '';
}
